/**
 * MobileBottomNav.js
 * 모바일 하단 고정 내비게이션 (엄지손가락 영역)
 * Mobile First 전략 - 390px 기준, 44px 터치 영역
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from '@mui/material';
import { Clock, CheckSquare, BarChart2 } from 'react-feather';
import { useTheme as useCustomTheme } from '../contexts/ThemeContext';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { colors, isDark } = useCustomTheme();

  // 현재 경로에 따라 활성 탭 결정
  const getCurrentValue = React.useCallback(() => {
    if (location.pathname.includes('/job-time-input') || location.pathname === '/m/log') {
      return 0;
    }
    if (location.pathname.includes('/todo-list') || location.pathname === '/m/todo') {
      return 1;
    }
    if (location.pathname.includes('/dashboard') || location.pathname === '/m/dashboard') {
      return 2;
    }
    // 관리자 페이지는 모바일에서 접근 불가 (PC 버전으로 리다이렉트)
    if (location.pathname.includes('/admin') || location.pathname === '/m/admin') {
      return 2; // 대시보드로 표시 (실제로는 PC로 리다이렉트됨)
    }
    return 0;
  }, [location.pathname]);

  const [value, setValue] = React.useState(getCurrentValue());

  React.useEffect(() => {
    setValue(getCurrentValue());
  }, [getCurrentValue]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    
    switch (newValue) {
      case 0:
        navigate('/m/log');
        break;
      case 1:
        navigate('/m/todo');
        break;
      case 2:
        navigate('/m/dashboard');
        break;
      default:
        break;
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: isDark ? '#1C1D22' : '#FFFFFF',
        borderTop: `1px solid ${colors.primaryBorder}`,
        // 모바일 최적화: 터치 영역 확보
        '& .MuiBottomNavigationAction-root': {
          minWidth: '43px',
          minHeight: '43px',
          padding: '5px 10px',
          color: colors.secondaryText,
          gap: '4px',
          '&.Mui-selected': {
            color: colors.accent,
          },
          '& .MuiBottomNavigationAction-label': {
            display: 'none', // 텍스트 숨김
          },
          '& .MuiBottomNavigationAction-icon': {
            fontSize: '30px !important',
            width: '30px',
            height: '30px',
            '& svg': {
              width: '30px !important',
              height: '30px !important',
            },
          },
        },
      }}
      elevation={3}
    >
      <BottomNavigation
        value={value}
        onChange={handleChange}
        showLabels={false}
        sx={{
          backgroundColor: 'transparent',
          height: '55px', // 엄지손가락 영역 확보 (61px의 90%)
          paddingBottom: '5px', // 하단 여백 조정
        }}
      >
        <BottomNavigationAction
          icon={<Clock size={30} />}
          sx={{ 
            minHeight: '43px',
            paddingTop: '5px',
            paddingBottom: '5px',
            '& .MuiBottomNavigationAction-icon': {
              '& svg': {
                width: '30px !important',
                height: '30px !important',
              },
            },
          }}
        />
        <BottomNavigationAction
          icon={<CheckSquare size={30} />}
          sx={{ 
            minHeight: '43px',
            paddingTop: '5px',
            paddingBottom: '5px',
            '& .MuiBottomNavigationAction-icon': {
              '& svg': {
                width: '30px !important',
                height: '30px !important',
              },
            },
          }}
        />
        <BottomNavigationAction
          icon={<BarChart2 size={30} />}
          sx={{ 
            minHeight: '43px',
            paddingTop: '5px',
            paddingBottom: '5px',
            '& .MuiBottomNavigationAction-icon': {
              '& svg': {
                width: '30px !important',
                height: '30px !important',
              },
            },
          }}
        />
        {/* 관리자 메뉴 제거: 모바일에서는 DB관리 접근 불가, PC 버전에서만 접근 가능 */}
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomNav;

